import { NgModule } from '@angular/core';

import { WeatherboyComponent } from './weatherboy.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  exports: [WeatherboyComponent],
  declarations: [WeatherboyComponent],
  providers: [],
})
export class WeatherboyModule { }
